import './App.css'
import { useState, useEffect } from 'react'
import { PRODUCTS } from './components/data/Products'
import { CATEGORIES } from './components/data/Categories'
import { Home, Collection, About, Contact} from "./components/pages/frontend"
import { Dashboard, Users, Account, Customers, Products, Orders, Categories, Login } from "./components/pages/backend"
import { View, ViewByCategory } from "./components/pages/frontend/products"
import { Profile } from './components/pages/frontend/account'
import { SignIn, SignUp } from './components/pages/auth'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import AuthRequired from './AuthRequired'
import Main from './components/layouts/Main'
import SideBar from './components/layouts/SideBar'
import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollToTop from './helpers/ScrollToTop'


AOS.init();

function App() {
  // const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);

  const products = PRODUCTS;
  const categories = CATEGORIES;

  // use effect to get products data when the app is loaded
  // useEffect(() => {
  //   setProducts(PRODUCTS);
  // }, []);

  // Handling the click to add product to cart
  const handleClick = (product) => {
    if (cart.some((cartItem) => cartItem.id === product.id)) {
      setCart((cart) =>
        cart.map((cartItem) =>
          cartItem.id === product.id
            ? {
                ...cartItem,
                amount: cartItem.amount + 1
              }
            : cartItem
        )
      );
      return;
    }

    // Setting the initial amount of product to 1
    setCart((cart) => [
      ...cart,
      { ...product, amount: 1 } // <-- initial amount 1
    ]);
  };

  // Handling the amount of product in cart
  const handleChange = (id, d) => {
    setCart((cart) =>
      cart.flatMap((cartItem) =>
        cartItem.id === id
          ? cartItem.amount + d < 1
            ? [] // <-- remove item if amount will be less than 1
            : [
                {
                  ...cartItem,
                  amount: cartItem.amount + d
                }
              ]
          : [cartItem]
      )
    );
  };

  return (
      <div className="App bg-white">
        <Router>
          <ScrollToTop/>
          <Routes>

            <Route path="/sign-in" exact Component={SignIn}/>
            <Route path="/sign-up" exact Component={SignUp}/>
            <Route path="/login" exact Component={Login}/>

              <Route element={<Main cart={cart} categories={categories} setCart={setCart} handleChange={handleChange}/>}>
                <Route path="/" exact element={
                  <Home products={products} categories={categories}/>
                }/>
                <Route path="/profile" exact Component={Profile}/>
                <Route path="/about-us" exact Component={About}/>
                <Route path="/contact-us" exact Component={Contact}/>
                <Route path="/new-collection" element={
                  <Collection products={products} categories={categories} handleClick={handleClick} />
                }/>
                <Route path="/product/:id" element={
                  <View products={products} handleClick={handleClick} />
                }/>
                <Route path="/:category" element={
                  <ViewByCategory products={products} handleClick={handleClick} />
                }/>
              </Route>

              {/* <Route element={<AuthRequired /> } /> */}
                <Route path='/admin' exact element={<SideBar/>}>
                  <Route path="/admin/" element={
                    <Dashboard/>
                  }/>
                  <Route path="/admin/users" element={
                    <Users />
                  }/>
                  <Route path="/admin/account" element={
                    <Account/>
                  }/>
                  <Route path="/admin/customers" element={
                    <Customers/>
                  }/>
                  <Route path="/admin/orders" element={
                    <Orders/>
                  }/>
                  <Route path="/admin/products" element={
                    <Products products={products} categories={categories}/>
                  }/>
                  <Route path="/admin/categories" element={
                    <Categories categories={categories}/>
                  }/>
                </Route>

            </Routes>
        </Router>
      </div>
  );
}

export default App;
